import { CipCodeCutoffFilter } from '@cpd-app/generated';

export const cipCodeCutoffFilterMapper = (
  cipCodeCutoff: number
): CipCodeCutoffFilter => {
  switch (cipCodeCutoff) {
    case 1:
      return CipCodeCutoffFilter.SomewhatRelated;
    case 3:
      return CipCodeCutoffFilter.RelatedField;
    case 5:
      return CipCodeCutoffFilter.CloselyRelated;
    case 7:
      return CipCodeCutoffFilter.Recommended;
    default:
      /**
       * OC-1. This fell back to Any, so an unrecognised value silently widened
       * the school search to its broadest setting rather than narrowing it.
       * A value that arrives here is one this mapper does not understand, and
       * the safe reading of "I do not know what you asked for" is the default
       * the list already claims in its own heading -- Recommended, the
       * RECOMMENDED_CUTOFF the container ships with -- not everything.
       */
      return CipCodeCutoffFilter.Recommended;
  }
};
